import React, { Component } from 'react';
import { withRouter, Route } from 'react-router';
import { Dropdown, Header, Dimmer, Loader, Table, Grid, Form, Input, Segment, Button } from 'semantic-ui-react';
import { isDefined, mascaraData, decimalFormat } from '../../util/Common';
import * as LocalStorageManager from '../../util/StorageManager';
import Moment from 'moment';
import { If } from '../../components/ConditionalRendering';
import HttpService from '../../util/HttpService';
import DatePicker from 'react-datepicker';
import DetalhePedido from './DetalhePedido';

import 'react-datepicker/dist/react-datepicker.css';

class PedidoVenda extends Component {

    constructor(){
        super();
        this.state = {
			codigo: '',
			cliente: [],
			dataInicial: new Moment(),
			dataFinal: new Moment(),
			nota: '',
			clientes: undefined,
			pedidos: undefined,
			isLoading: false
        }
	}

	componentDidMount(){
		this.buscarClientes();
        this.buscarPedidos();
	}

	buscarClientes = () => {
		const user = LocalStorageManager.getLoggedUser();

		if(user.isCliente){
			// Seta o cliente selecionado como o proprio cliente logado
			this.setState({ cliente: [user.idt] })
		}else{
			HttpService.call(
				'sistema/combos',
				'clientes',
				[
					// idt do vendedor
					user.idt
				],
				(clientes) => this.setState({ clientes })
			);
		}
	}

	buscarPedidos = () => {
		const { codigo, nota, cliente, dataInicial, dataFinal } = this.state;
		const user = LocalStorageManager.getLoggedUser();

		this.setState({ isLoading: true });

		HttpService.call(
            'cadastro/orcamentoVenda',
			'buscarPedidos',
			[
				codigo,
				nota,
				user.isCliente ? [ user.idt ] : cliente, // Se for cliente, utiliza o proprio idt do cliente como parametro
				dataInicial.format('YYYYMMDD'),
				dataFinal.format('YYYYMMDD'),
				LocalStorageManager.getOrigem().idt,
				'N', // isOrcamento = 'N', são os pedidos fechados
				!user.isCliente ? user.idt : '' // idt do vendedor, caso nao seja cliente.
			],
			(pedidos) => this.setState({ pedidos, isLoading: false })
        );
	}

    render() {
		const { codigo, cliente, dataInicial, dataFinal, nota } = this.state;

		return (
			<div>
				<Grid centered>
					<Grid.Column mobile={16} tablet={16} computer={16}>						
						<Segment.Group className='white-background'>
							<Segment>
								<Header>Pedidos</Header>
							</Segment>
							<Segment.Group>
								<Segment size='mini' clearing attached='top' secondary>
									<Form size='tiny' onSubmit={() => this.buscarPedidos()}>
										<Form.Group>
											<Form.Field width={4} control={Input} label='Código' name='codigo' value={ codigo } onChange={(e, {value}) => this.setState({ codigo: value.toUpperCase() })} />
											<If test={LocalStorageManager.getLoggedUser().isCliente}>
												<Form.Field width={12}>
													<label>Cliente</label>
													<Input disabled value={ LocalStorageManager.getLoggedUser().nome } />
												</Form.Field>
											</If>
											<If test={!LocalStorageManager.getLoggedUser().isCliente}>
												<Form.Field width={12} control={Dropdown} label='Cliente'
														fluid search multiple selection selectOnBlur={false}
														placeholder='Nome do cliente' 
														noResultsMessage='Nenhum resultado encontrado' 
														value={cliente}
														options={this.state.clientes}
														loading={this.state.clientes === undefined}
														onChange={(e, { value }) => this.setState({ cliente: value })}/>
											</If>
										</Form.Group>
										<Form.Group widths='equal'>
											<Form.Field control={Input} label='Nota' name='nota' value={ nota } onChange={(e, {value}) => this.setState({ nota: value })} />
											<Form.Field control={DatePicker} required label='Data Inicial' selected={ dataInicial } maxDate={ dataFinal } onChange={ (dataInicial) => this.setState({ dataInicial }) } onChangeRaw={(event) => event.target.value = mascaraData(event.target.value)} />
											<Form.Field control={DatePicker} required label='Data Final' selected={ dataFinal } minDate={ dataInicial } onChange={ (dataFinal) => this.setState({ dataFinal }) } onChangeRaw={(event) => event.target.value = mascaraData(event.target.value)} />
											<Form.Button className='vertical-align-bottom' color='teal' content='Pesquisar' icon='search' compact fluid floated='right' size='medium' type='submit'/>
										</Form.Group>
									</Form>
								</Segment>
								<Dimmer active={this.state.isLoading} inverted>
									<Loader inverted content='Carregando'/>
								</Dimmer>
								<Segment attached className='clean-scrollbar'>
									<Table compact striped selectable singleLine size='small'>
										<Table.Header>
											<Table.Row>
											<Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
											<Table.HeaderCell textAlign='center'>Cliente</Table.HeaderCell>
											<Table.HeaderCell textAlign='center'>Data</Table.HeaderCell>
											<Table.HeaderCell textAlign='center'>Nota</Table.HeaderCell>
											<Table.HeaderCell textAlign='center'>Itens</Table.HeaderCell>
											<Table.HeaderCell textAlign='center'>Valor (R$)</Table.HeaderCell>
											<Table.HeaderCell textAlign='center'>Frete (R$)</Table.HeaderCell>
											<Table.HeaderCell textAlign='center'></Table.HeaderCell>
											</Table.Row>
										</Table.Header>
										<Table.Body>
										{   
											isDefined(this.state.pedidos) && this.state.pedidos.registros > 0 ? (
												this.state.pedidos.lista.map((item) => {
													return <Table.Row key={item.idt} style={{ cursor: 'pointer' }} onDoubleClick={() => this.props.history.push(this.props.match.url + '/' + item.idt)}>
																<Table.Cell textAlign='center'>{item.idt}</Table.Cell>
																<Table.Cell textAlign='left'>{item.nomeCliente}</Table.Cell>
																<Table.Cell textAlign='center'>{item.dataPedido}</Table.Cell>
																<Table.Cell textAlign='center'>{item.nota}</Table.Cell>
																<Table.Cell textAlign='center'>{item.quantidadeItens}</Table.Cell>
																<Table.Cell textAlign='right'>{decimalFormat(item.valorTotal, 2)}</Table.Cell>
																<Table.Cell textAlign='right'>{decimalFormat(item.valorFrete, 2)}</Table.Cell>
																<Table.Cell textAlign='right'>
																	<Button size='mini' color='blue' title='Visualizar detalhes' icon='search' onClick={() => this.props.history.push(this.props.match.url + '/' + item.idt)}/>
																</Table.Cell>
															</Table.Row>
												})
											) : (
												<Table.Row>
													<Table.Cell colSpan='8'>Nenhum registro encontrado.</Table.Cell>
												</Table.Row>
											)
										}
										</Table.Body>
									</Table>
								</Segment>
								<Segment size='mini' clearing attached='bottom'>
									<Button negative content='Fechar' floated='left' icon='window close' onClick={() => this.props.history.push('/main')} />
								</Segment>
							</Segment.Group>  
						</Segment.Group>
					</Grid.Column>
				</Grid>

				<Route path="/main/pedidos/:idtPedido" component={DetalhePedido}/>
			</div>
        )
    }
}

export default withRouter(PedidoVenda);


// WEBPACK FOOTER //
// ./src/views/PedidoVenda/index.js